import { UseQueryOptions } from "react-query";
import { useModelService } from "@shared/services/api/hooks/useModelService";
import UserBasedVenueEmploymentRepository from "../../repositories/UserBasedVenueEmploymentRepository";
import { UserBasedVenueEmployment } from "../../types/venue-employments";

const useUserVenueEmploymentsService = () => {
  const repository = new UserBasedVenueEmploymentRepository();
  const { useList: useListBase } = useModelService(repository);

  const useList = (params?: {
    options?: UseQueryOptions<UserBasedVenueEmployment[]>;
  }) => {
    return useListBase({
      options: {
        // Default: cache employments for 5 minutes - balance between performance and freshness
        staleTime: 300000, // 5 minutes
        ...params?.options,
      },
    });
  };

  return {
    useList,
  };
};

export default useUserVenueEmploymentsService;
